<template>
  <div class="design-checkbox-wrapper" :class="{ checked, small: size === 'small' }">
    <input type="checkbox" class="design-checkbox" :checked="checked" :indeterminate.prop="indeterminate" @change="onChange" />
    <div class="design-checkbox-ripple" @click="onClick"></div>
    <i v-if="!checked" class="mdi mdi-checkbox-blank-outline design-checkbox-icon"></i>
    <i v-else class="mdi mdi-checkbox-marked design-checkbox-icon"></i>
  </div>
</template>
<script>
export default {
  name: 'DesignCheckbox',
  props: {
    value: {
      type: [String, Boolean, Number, Array],
      required: true
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: ''
    },
    id: {
      type: [String, Boolean, Number],
      required: false
    },
    name: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    checked() {
      if (Array.isArray(this.value)) {
        return this.value.indexOf(this.id) > -1;
      } else {
        return !!this.value;
      }
    }
  },
  methods: {
    onChange(event) {
      this.toggle(event.target.checked);
    },
    onClick() {
      const newValue = !this.checked;
      this.toggle(newValue);
    },
    toggle(value) {
      if (Array.isArray(this.value)) {
        if (value) {
          this.$emit('input', [...this.value, this.id]);
        } else {
          this.$emit(
            'input',
            this.value.filter((v) => v !== this.id)
          );
        }
      } else {
        this.$emit('input', value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.design-checkbox-wrapper {
  position: relative;
  height: 24px;
  margin-right: 6px;

  i {
    font-size: 24px;
  }

  .design-checkbox {
    -webkit-appearance: none; /* 웹킷 브라우저에서 기본 스타일 제거 */
    -moz-appearance: none; /* Firefox에서 기본 스타일 제거 */
    appearance: none; /* 표준화된 기본 스타일 제거 */
    position: absolute;
  }

  .design-checkbox-ripple {
    cursor: pointer;
    position: absolute;
    width: 24px;
    height: 24px;
  }

  .design-checkbox-icon {
    color: #919191;
  }

  &.checked {
    .design-checkbox-icon {
      color: #5578f0;
    }
  }

  &.small {
    height: 20px;
    i {
      font-size: 20px;
    }

    .design-checkbox-ripple {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
